<template>
  <div class="px-4 py-2 w-full">
    <div class="flex bg-gray-900 rounded-2xl p-2 ">
      <div class=" w-28 h-28 flex-shrink-0" >
      <img 
        class="Object-cover w-full h-full " 
        :src="`${baseurl}/${product.imageUrl}`" 
        @click="showModal = true" 
        @error="$event.target.src = require('@/assets/placeholder.png')">
      </div>
      <div class="p-2 mr-2">
        <h1 class="text-white text-sm">{{ product.name }}</h1>
        <h5 class="text-yellow-500 text-sm mt-3">
          {{ $t('Price') }}
         {{ $helper.priceFormatter(product.price) }}
         {{ currency }}
        </h5>
        <h6 class="text-gray-400 text-xs mt-2" v-if="!!product.serviceTagList[0]">
          شرح:
          <div class="inline-flex items-stretch rounded-lg" v-for="tag in product.serviceTagList" :key="tag">
            <button class="bg-green-500 text-white text-xs py-1 px-1 rounded-lg">
              {{ tag }}
            </button>
          </div>
        </h6>
      </div>
    </div>
    <modal v-if="showModal" :src="`${baseurl}/${product.imageUrl}`" @close="showModal = false" />
  </div>
</template>

<script>
import Modal from './General/Modal.vue';

export default {
  name: "HorizontalFoodCard",
  components: {
    Modal
  },
  created(){
    //console.log(this.product);

  },
  data() {
    return {
      showModal: false,
      
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    baseurl: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
  }
}
</script>
<style scoped>
.object-cover {
  object-fit: fill;
}
</style>
